export default "__VITE_ASSET__b99671b7__"